import { useState, useEffect } from "react";
import SideMenu from "../../features/sideMenu/SideMenu";
import { itemsSoporte } from "../../constants/soporte";
import { descargarManual, subirArchivoManual } from "../functions/Soporte";
import {
  Snackbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ModalSubirArchivo from "../../ui/ModalSubirArchivo";

const NormativaCFE = ({ API_URL }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [type, setType] = useState(null);

  const [openModal, setOpenModal] = useState(false);

  const [normativaPdf, setNormativaPdf] = useState({
    url: null,
    loading: false,
    fetched: false,
  });

  const [autoabastoPdf, setAutoabastoPdf] = useState({
    url: null,
    loading: false,
    fetched: false,
  });

  const [mercadoPdf, setMercadoPdf] = useState({
    url: null,
    loading: false,
    fetched: false,
  });

  const [requerimientosPdf, setRequerimientosPdf] = useState({
    url: null,
    loading: false,
    fetched: false,
  });

  const [criteriosPdf, setCriteriosPdf] = useState({
    url: null,
    loading: false,
    fetched: false,
  });

  const fetchPdf = async (tipoManual, setState) => {
    try {
      setState((prev) => ({ ...prev, loading: true }));
      const blob = await descargarManual(API_URL, tipoManual);
      const url = URL.createObjectURL(blob);
      setState({ url, loading: false, fetched: true });
    } catch (error) {
      setState((prev) => ({ ...prev, loading: false }));
      setSnackbarMessage(`Error al cargar el manual de ${tipoManual}`);
      setShowSnackbar(true);
    }
  };

  const handleAccordionChange =
    (tipoManual, state, setState) => (event, isExpanded) => {
      if (isExpanded && !state.fetched && !state.loading) {
        fetchPdf(tipoManual, setState);
      }
    };

  useEffect(() => {
    return () => {
      if (normativaPdf.url) URL.revokeObjectURL(normativaPdf.url.split("#")[0]);
      if (autoabastoPdf.url)
        URL.revokeObjectURL(autoabastoPdf.url.split("#")[0]);
      if (mercadoPdf.url) URL.revokeObjectURL(mercadoPdf.url.split("#")[0]);
      if (requerimientosPdf.url)
        URL.revokeObjectURL(requerimientosPdf.url.split("#")[0]);
      if (criteriosPdf.url) URL.revokeObjectURL(criteriosPdf.url.split("#")[0]);
    };
  }, [
    normativaPdf.url,
    autoabastoPdf.url,
    mercadoPdf.url,
    requerimientosPdf.url,
    criteriosPdf.url,
  ]);

  const renderPdfContent = (state) => {
    if (state.loading) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="600px"
        >
          <CircularProgress />
        </Box>
      );
    }
    if (state.url) {
      return (
        <iframe
          title="Manual"
          src={state.url}
          width="100%"
          height="600px"
          style={{ border: "none" }}
        />
      );
    }
    return null;
  };

  const handleUploadManual = (file) => {
    if (type && file) {
      subirArchivoManual(API_URL, file, type)
        .then((res) => {
          setSnackbarMessage("Archivo subido correctamente");
          setShowSnackbar(true);
        })
        .catch((err) => {
          setSnackbarMessage("Error al subir el archivo");
          setShowSnackbar(true);
        });
    }
  };

  return (
    <div className="mi-container" style={{ display: "flex", width: "100%" }}>
      <div className="mi-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsSoporte} />
      </div>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />

      <ModalSubirArchivo
        open={openModal}
        onClose={() => setOpenModal(false)}
        onConfirm={handleUploadManual}
        accept={{ "application/pdf": [] }}
      />

      <div
        className="mi-main"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          padding: "10px",
          gap: "10px",
        }}
      >
        <h1 className="map-title" style={{ margin: 0 }}>
          Normativa de CFE
        </h1>

        <Accordion
          onChange={handleAccordionChange(
            "NORMATIVA_CFE",
            normativaPdf,
            setNormativaPdf
          )}
        >
          <AccordionSummary
            className="accordion-summary-no-margin"
            expandIcon={<ExpandMoreIcon />}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "270px auto",
                alignItems: "center",
              }}
            >
              <p style={{ display: "flex", alignItems: "center", margin: 0 }}>
                <strong>Norma Eléctrica de CFE</strong>
              </p>
              <div
                style={{
                  backgroundColor: "#223D51",
                  color: "#FFFFFF",
                  padding: "4px 10px",
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "14px",
                  cursor: "pointer",
                  fontFamily: "Nunito",
                  marginLeft: "20px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setType("NORMATIVA_CFE");
                  setOpenModal(true);
                }}
              >
                Reemplazar manual
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>{renderPdfContent(normativaPdf)}</AccordionDetails>
        </Accordion>

        <Accordion
          onChange={handleAccordionChange(
            "AUTOABASTO",
            autoabastoPdf,
            setAutoabastoPdf
          )}
        >
          <AccordionSummary
            className="accordion-summary-no-margin"
            expandIcon={<ExpandMoreIcon />}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "270px auto",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                  fontFamily: "Nunito",
                }}
              >
                <strong>Autoabasto y Contratos Legados</strong>
              </p>
              <div
                style={{
                  backgroundColor: "#223D51",
                  color: "#FFFFFF",
                  padding: "4px 10px",
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "14px",
                  cursor: "pointer",
                  fontFamily: "Nunito",
                  marginLeft: "20px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setType("AUTOABASTO");
                  setOpenModal(true);
                }}
              >
                Reemplazar manual
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>{renderPdfContent(autoabastoPdf)}</AccordionDetails>
        </Accordion>

        <Accordion
          onChange={handleAccordionChange(
            "MERCADO_ELECTRICO",
            mercadoPdf,
            setMercadoPdf
          )}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            className="accordion-summary-no-margin"
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "270px auto",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                  fontFamily: "Nunito",
                }}
              >
                <strong>Mercado Eléctrico Mayorista (MEM)</strong>
              </p>
              <div
                style={{
                  backgroundColor: "#223D51",
                  color: "#FFFFFF",
                  padding: "4px 10px",
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "14px",
                  cursor: "pointer",
                  fontFamily: "Nunito",
                  marginLeft: "20px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setType("MERCADO_ELECTRICO");
                  setOpenModal(true);
                }}
              >
                Reemplazar manual
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>{renderPdfContent(mercadoPdf)}</AccordionDetails>
        </Accordion>

        <Accordion
          onChange={handleAccordionChange(
            "REQUERIMIENTOS",
            requerimientosPdf,
            setRequerimientosPdf
          )}
        >
          <AccordionSummary
            className="accordion-summary-no-margin"
            expandIcon={<ExpandMoreIcon />}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "270px auto",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                  fontFamily: "Nunito",
                }}
              >
                <strong>Manual de Requerimiento TICs</strong>
              </p>
              <div
                style={{
                  backgroundColor: "#223D51",
                  color: "#FFFFFF",
                  padding: "4px 10px",
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "14px",
                  cursor: "pointer",
                  fontFamily: "Nunito",
                  marginLeft: "20px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setType("REQUERIMIENTOS");
                  setOpenModal(true);
                }}
              >
                Reemplazar manual
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            {renderPdfContent(requerimientosPdf)}
          </AccordionDetails>
        </Accordion>

        <Accordion
          onChange={handleAccordionChange(
            "CRITERIOS",
            criteriosPdf,
            setCriteriosPdf
          )}
        >
          <AccordionSummary
            className="accordion-summary-no-margin"
            expandIcon={<ExpandMoreIcon />}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "270px auto",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                  fontFamily: "Nunito",
                }}
              >
                <strong>Criterios de Aceptación</strong>
              </p>
              <div
                style={{
                  backgroundColor: "#223D51",
                  color: "#FFFFFF",
                  padding: "4px 10px",
                  borderRadius: "5px",
                  fontWeight: 700,
                  fontSize: "14px",
                  cursor: "pointer",
                  fontFamily: "Nunito",
                  marginLeft: "20px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setType("CRITERIOS");
                  setOpenModal(true);
                }}
              >
                Reemplazar manual
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>{renderPdfContent(criteriosPdf)}</AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default NormativaCFE;
